import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonial',
  templateUrl: './testimonial.component.html',
  styleUrls: ['./testimonial.component.scss']
})
export class TestimonialComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  testimonials = [
    {
      "author": "桑原 拓也 博士",
      "designation": "日本工業大学 基幹工学部 機械工学科 教授",
      "message": "Trinkaは学術論文や講演論文の執筆に大いに役立っています。人の目では見逃してしまうミスもチェックされ、論文執筆における安心感も得られ、ネイティヴ講師の英文校正作業の効率も大幅にアップしています。大学の英語学習サポートセンターを利用する動機や、ネイティヴ講師と会話する話題づくりにもなっています。",
      "photo": "clientPhotos/takuya-kuwahara.png"
    },
    {
      "author": "ウーゴ・アルベルト・リヴェラ・ロドリゲス 様",
      "designation": "コロンビア ロサリオ大学助教授",
      "message": "Trinkaで出版した論文を改善できました。また改訂に加え、私の研究に沿ったジャーナルの提案もしてくれました。",
      "photo": "clientPhotos/hugo.jpg"
    },
    {
      "author": "ミハル・プラチェク 様",
      "designation": "チェコ共和国 カレル大学公共・社会政策学部教授",
      "message": "Trinkaで研究作業が大幅に効率化できました。英語が母語でない私は、論文を仕上げる前に英文校正サービスを利用してきましたが、これには時間も、多額の費用もかかりました。Trinkaのおかげで、研究そのものに多くの時間を費やすことができます。",
      "photo": "clientPhotos/michal.jpg"
    },
    {
      "author": "ドミトリー・ベロウソフ 様",
      "designation": "ロシア OKI出版マネージングエディター",
      "message": "Trinkaを使い始めて数年ですが、とても良い印象を持っています。文章の質を向上させるのに本当に役立つツールです。特に気に入ったのは文法とスタイルのチェッカーで、細かい誤りを見つけるだけでなく、適切な修正を提案してくれます。直感的なプログラムのインターフェイスで、初めてのユーザーでも使いやすいです。出版関係者にとっては多目的に使えるツールで、ライティングスキルを向上させたいすべての人にお勧めします。",
      "photo": "clientPhotos/dmitry-belousov.png"
    },
    // {
    //   "author": "James Smith",
    //   "designation": "Academic Editor, USA",
    //   "message": "First, I love Trinka. Congratulations on developing something that extensively aids editing, especially critical grammar conventions and word count reductions.",
    //   "photo": "clientPhotos/James-Smith.jpg"
    // },
    // {
    //   "author": "Edith Davies",
    //   "designation": "PhD Scholar, UK",
    //   "message": "I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar checkers I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is widely used in academia.",
    //   "photo": "clientPhotos/Edith-Davies.jpg"
    // },
    {
      "author": "ラケル・ロドリゲス 様",
      "designation": "ブラジル ミナス・ジェライス連邦大学博士課程学生",
      "message": "このプラットフォームは、文法の修正だけでなく、文章のまとまりや一貫性の向上にも大いに役立ちいます。盗用・剽窃レポートと引用チェックツールは本当に優れています。",
      "photo": "clientPhotos/raquel_rodrigues.jpg"
    },
    {
      "author": "ダイク・ギャレス 様",
      "designation": "ハンガリー デブレツェン大学研究員",
      "message": "Trinkaは、自分で書いた論文の編集作業をプラットフォーム上でチェックするときに、とても便利だと思いました。また、ジャーナル編集者／出版社にとっても興味深く、ポテンシャルのあるツールだと思います。",
      "photo": "clientPhotos/Dyke-Gareth.jpg"
    },
        // {
    //   "author": "Dmitry Belousov",
    //   "designation": "OKI Publishing House, Russian Federation",
    //   "message": "We have been using the Trinka AI online service for more than a year to check the abstracts of medical articles and to check translations of articles from Russian to English. During this period, the Trinka AI service was excellent. We recommend it to our colleagues.",
    //   "photo": "clientPhotos/belousov.jpg"
    // },
    {
      "author": "テオ・ファン・レーウェン 様",
      "designation": "インドネシア Rio Tinto Exploration SE Asiaマネージャー ",
      "message": "インドネシア Rio Tinto Exploration SE Asiaマネージャー この数年、Trinkaを使って、自分の学術的な文章（地質学）をチェックしています。他にいくつかのプログラムを試しましたが、その中でTrinkaは最高でした。質問に対して答えてくれるサービスも素晴らしいです。",
      "photo": "clientPhotos/theo-van-leeuwen.jpg"
    },
        // {
    //   "author": "Abba Kasim",
    //   "designation": "Researcher, FUDMA, Nigeria",
    //   "message": "The Trinka platform is intuitive and easy to navigate. Most importantly, the plagiarism checker is a game-changer! It gives me confidence that my work is original and free from unintentional copying, which is crucial for academic integrity.",
    //   "photo": "clientPhotos/abba-kasim.jpg"
    // },
        {
      "author": "アブディ・ユスフ 様",
      "designation": "エチオピア ジジガ大学シニアレクチャラー兼人事部長",
      "message": "この1年間Trinkaを使ってきましたが、ライティングプロセスが大幅に改善しました。高度な文法とスタイルの提案は、私の文章をより洗練されたプロフェッショナルなものにしてくれました。Trinkaは単なるツールというよりも、ライティングの質を高めたい人にとっての良いパートナーです。文章に明瞭さと正確さを求めるすべての人にお勧めします。",
      "photo": "clientPhotos/abdi-yusuf.jpg"
    },
    {
      "author": "ロサ・ディアス＝サンドヴァル 様",
      "designation": "メキシコ 物理学・数学博士",
      "message": "英語の文章を、正しい文法とスタイルで書くことは非英語圏の人間にとっては簡単ではありません。アカデミックな文章を書く場合、助けを借りなければ小さなミスも見つけられません。私は自動修正ツールとしてTrinkaを試しましたが、提案された修正とフィードバックにとても満足しています。フィードバックがあることで、なぜ修正しなければならないかも理解できます。",
      "photo": "clientPhotos/Rosa-Diaz-Sandoval.jpg"
    },
    {
      "author": "ジェシー・ランボール＝スミス 様",
      "designation": "ニュージーランド ウェリントンカレッジ学生",
      "message": "他の英文チェッカーやライティングアシスタントは、無料プランでは、全ての機能は利用できませんでした。学生身分の自分にとっては無料プランで様々な機能が使えるのは本当にありがたいです。これは素晴らしい製品で、収入があれば間違いなくプレミアムにアップグレードするでしょう。本当に助かるサービスなので、学生仲間にも機会があればTrinkaについていつも話しています。",
      "photo": "clientPhotos/Noor-Al-rishi.png"
    },
    {
      "author": "ンワジ・ジュード 様",
      "designation": "イギリス チェスター大学",
      "message": "Trinkaの使用感は素晴らしく、Trinkaで再チェックせずに原稿を提出することができなくなってしまったほどです。一言で言って、命の恩人です。",
      "photo": "clientPhotos/Nwaji-Jude.jpg"
    },
    {
      "author": "アブドラ・マチャノ 様",
      "designation": "タンザニア ジティマイ病院総合医およびKadi Hai創設者兼ディレクター",
      "message": "Trinkaで、アカデミックライティングが大幅に向上しました。文法やスペルのミスを素早く正確に特定できるようになり、自分の文章に自信が持てるようになりました。",
      "photo": "clientPhotos/abdalla-machano.jpg"
    },
    {
      "author": "ダウダ・アユバ 様",
      "designation": "ナイジェリア アフマド・ベロ大学研究助手",
      "message": "2023年からTrinkaの、特に英文校正の機能を利用しています。この機能では、文法のチェックと修正、スペル、ライティングのアドバイス、原稿の強化を行えます。プラットフォームの直感的なデザインと包括的なフィードバックのおかげでライティングスキルが随分向上したように思います。文脈に応じた提案機能もあり、論文を明瞭かつ正確にするための傑出したツールです。ライティングの質を向上させたいと考えているすべての人に強くお勧めします。",
      "photo": "clientPhotos/d-ayuba.jpg"
    },
    {
      "author": "ファルーク・ラトール 様",
      "designation": "パキスタン　大学助教授・学部長",
      "message": "主に、国内外の生物医学ジャーナルに投稿する論文原稿の英語の文法、構文を改善するために使用しています。使いやすく、手順も効率的で手間がかかりません。ファイル自動校正や、出版適正チェックなどの優れた機能もありがたいです。",
      "photo": "clientPhotos/Dr_Farooq_Rathore.jpg"
    },
    {
      "author": "マリヤム・ラズムギア 博士",
      "designation": "イラン医療科学大学 准教授",
      "message": "ライティングと文法チェックにTrinkaを使いました。文法の間違いをより早く見つけて修正するのに役立ち、ライティングの上達にも役立ちました。Trinkaの使用は自分にとって良い経験になりました。",
      "photo": "clientPhotos/maryam.png"
    },
    {
      "author": "ニティン・ワヒ 博士",
      "designation": "インド Pathfinder Research and Training institute",
      "message": "Trinka は研究発表に慣れていない人間をサポートする素晴らしいツールです。英文校正、オンラインでのファイル一括校正、引用チェックツール、盗用・剽窃レポート、パラフレーズツール、出版適正チェックなど、驚きの機能を簡単に利用できます。無料のベーシックプランでさえ、大学院生や若手の研究者にとっては非常に貴重で、プロジェクトレポートや論文を出版基準に合うように改善する上で役立ちます。Trinkaには非常に感心させられています。他の人々にもぜひ試してみて欲しいと思います。貴重なツールを提供してくれたTrinkaのチームに感謝します。",
      "photo": "clientPhotos/client-photo.jpg"
    },
    // {
    //   "author": "Dinesh Gupta",
    //   "designation": "Radiologist, India",
    //   "message": "The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked earlier with Grammarly. I was pleasantly surprised to see such a product from India!",
    //   "photo": "clientPhotos/Dinesh-Gupta.jpg"
    // },
    
    // {
    //   "author": "Ralph Bailey",
    //   "designation": "Neurologist, USA",
    //   "message": "Trinka has become my go-to tool for grammar corrections. The AI-powered corrections and language enhancements made writing a lot more easier. Now I am able to focus more on research than on writing an error-free document.",
    //   "photo": "clientPhotos/Ralph-Bailey.jpg"
    // },
    // {
    //   "author": "Thomas Andres",
    //   "designation": "Cardiologist, Brazil",
    //   "message": "The grammar correction and suggestion based on the AMA style guide is really impressive! Trinka is indeed the best grammar correction tool for medical writing.",
    //   "photo": "clientPhotos/Thomas-Andres.jpg"
    // }
  ]   

}
